import axios from "axios";

export const getShipmentTableApi = async (action, lang, cookies, customer_id) => {
  const token = cookies.__t0ken_amar_management;

  let data = JSON.stringify({
    action: action,
  });

  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API}/shipment-data/${customer_id}`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
